import { useEffect, useState } from "react";
import { useLanguage } from "@/hooks/useLanguage";

type Reaction = { id: string; emoji: string; key: string };

const POOL: Reaction[] = [
  { id: "chat", emoji: "🔥", key: "lrm_chat" },
  { id: "goal", emoji: "⚠️", key: "lrm_goal" },
  { id: "mex", emoji: "👀", key: "lrm_mex" },
  { id: "shock", emoji: "💥", key: "lrm_shock" },
  { id: "save", emoji: "🧤", key: "lrm_save" },
  { id: "var", emoji: "🟡", key: "lrm_var" },
];

/**
 * Lightweight, throttled live reactions strip.
 * Pure UI — no realtime fetches; rotates every ~7s to feel alive.
 */
export function LiveReactionMoments() {
  const { t } = useLanguage();
  const [items, setItems] = useState<Reaction[]>([POOL[0], POOL[1], POOL[2]]);

  useEffect(() => {
    const id = window.setInterval(() => {
      setItems((prev) => {
        const next = POOL[Math.floor(Math.random() * POOL.length)];
        if (prev[0]?.id === next.id) return prev;
        return [next, prev[0], prev[1]].filter(Boolean) as Reaction[];
      });
    }, 7000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <section
      aria-label={t("lrm_title")}
      className="rounded-2xl border border-border/60 bg-background/70 p-3 backdrop-blur"
    >
      <div className="mb-2 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
        {t("lrm_title")}
      </div>
      <ul className="space-y-1.5">
        {items.map((r, i) => (
          <li
            key={`${r.id}-${i}`}
            className="flex items-center gap-2 text-sm animate-fade-in"
            style={{ opacity: 1 - i * 0.25 }}
          >
            <span aria-hidden className="text-base">{r.emoji}</span>
            <span className="font-medium">{t(r.key)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
